<template>
  <main class="registration-container">
    <div class="registration login">
      <Logo />

      <div class="login__text-container">
        <p class="login__text">Välkommen tillbaka! Vänligen logga in med dina uppgifter.</p>
      </div>

      <div class="login__tabs">
        <Tabs
          v-for="tab in tabs"
          :key="tab.id"
          :tab="tab"
        />
      </div>

      <LoginForm :tab="tabs.find(tab=>tab.isActive)" :tabs="tabs" />
    </div>
  </main>
</template>

<script>
import { Tabs, LoginForm } from '@/components/';
import Logo from '../components/elements/Logo';

export default {
  name: 'Login',
  components: { Tabs, LoginForm, Logo },
  data () {
    return {
      tabs: [
        {
          id: 3,
          title: 'QR kod',
          isActive: true,
          btn: false
        },
        {
          id: 1,
          title: 'Mobilt BankID',
          isActive: false,
          btn: 'Logga in'
        },
        {
          id: 2,
          title: 'BankID',
          isActive: false,
          btn: 'Öppna BankID-applikationen'
        },
      ],
    }
  },
}
</script>